import {useState} from "react";
import PopUp from "../components/Popup";
import { NavLink } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { CgMenuGridO } from "react-icons/cg";
import { IconContext } from "react-icons";

import backgroundImg from "../photo/A2163AE9-C9F9-4772-8B5B-D0B7A6A78407_1_105_c.jpeg";

const Carousel = () => {
  const [openPopup, setOpenPopup] = useState(false);

  const handleRemovePopUp = () => setOpenPopup(false);

  // Ajoutez cette fonction dans votre composant Carousel
const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, to: string) => {
  if (to.includes('#') && to !== '#') {
    const id = to.replace('/#', '');
    const element = document.getElementById(id);

    if (element) {
      e.preventDefault();
      if (openPopup) setOpenPopup(false);
      const headerHeight = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
    // Si l'élément n'existe pas (on est sur une autre page), React Router navigue normalement vers /#about etc.
  }
};
  return (
    <div className="w-full overflow-hidden">
      {/* Header - Maintenant en dehors de la section vidéo */}
      <header className="bg-[#0B0B0F] z-20">
        <nav className="container mx-auto px-4 py-4 flex justify-between items-center">
          {/* Left Section: Menu sur mobile et logo */}
          <div className="flex items-center gap-4">
            <button 
              onClick={() => setOpenPopup(true)} 
              className="md:hidden p-2 hover:bg-gray-700/50 rounded-lg transition-colors"
              aria-label="Menu"
            >
              <IconContext.Provider value={{ size: "1.5em", className: "text-white" }}>
                <CgMenuGridO />
              </IconContext.Provider>
            </button>
            <NavLink to="/" className="flex items-center">
              <img 
                src="/images/LogoSansFond.png" 
                alt="YohanVision Logo" 
                className="h-16 w-16 object-contain"
                style={{ filter: 'drop-shadow(0 0 2px rgba(0,0,0,0.5))' }}
              />
            </NavLink>
          </div>

          {/* Popup Menu - uniquement sur mobile */}
          {openPopup && <PopUp openPopUp={openPopup} closePopUp={handleRemovePopUp} />}

          {/* Navigation Links - version desktop au centre, version mobile en popup */}
          <div className="hidden md:flex items-center justify-end flex-grow mx-8">
            {[
              { to: "/", label: "Accueil" },
              { to: "/#about", label: "À propos" },
              
              /** { to: "/Forfait", label: "Forfaits" }*/
              { to: "/#portfolio", label: "Portfolio" },
              { to: "/#contact", label: "Contactez-nous" }
            ].map((link) => (
              <NavLink
  key={link.to}
  to={link.to}
  onClick={(e) => handleSmoothScroll(e, link.to)}
  className={({ isActive }) =>
    link.to === "/#contact"
      ? "px-5 py-2 bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-500 bg-size-200 animate-gradient-x text-white rounded-lg hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300 transform hover:scale-105 ml-4 font-medium"
      : `px-5 py-2 text-white text-lg font-medium transition-all ${
          isActive && !link.to.includes("#") 
            ? "border-b-2 border-white"
            : "hover:text-gray-300"
        }`
  }
>
  {link.label}
</NavLink>
            ))}
          </div>

          {/* Right Section: Social Links */}
          <div className="flex items-center gap-4">
            {[
              { 
                href: "https://www.facebook.com/profile.php?id=100010381140256&locale=fr_CA",
                icon: FaFacebookF,
                label: "Facebook"
              },
              { 
                href: "https://www.instagram.com/yohan.p0v/",
                icon: FaInstagram,
                label: "Instagram"
              },
              { 
                href: "https://www.youtube.com/@yohan.p0v",
                icon: FaYoutube,
                label: "YouTube"
              }
            ].map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-200 transition-colors"
                aria-label={social.label}
              >
                <IconContext.Provider value={{ size: "1.5em" }}>
                  <social.icon />
                </IconContext.Provider>
              </a>
            ))}
          </div>
        </nav>
      </header>

      {/* Video Background - Maintenant après le header */}
      <div className="relative h-[60vh] md:h-[60vh] lg:h-[50vh] xl:h-[140vh] w-full">
        <div className="absolute inset-0 bg-black/30 z-10" /> {/* Overlay */}
        <img
          className="w-full h-full object-cover"
          src={backgroundImg}
          alt="Yohan Vision background"
        />
        {/* Hero Text */}
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-white mt-20">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 text-center tracking-tight">
            Yohan Vision
          </h1>
          <p className="text-xl md:text-2xl text-center max-w-2xl mb-8 text-gray-200">
            Capturer l'essence des moments précieux à travers l'objectif
          </p>
        </div>

        {/* Bottom Border */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-white to-transparent opacity-50" />
      </div>
    </div>
  );
};

export default Carousel;